module.exports = __webpack_public_path__ + "static/media/heatbliss-logo.c0875df5.png";